export default __webpack_public_path__ + "assets/pdf/termodeuso.1268d8b9.pdf";